<div class="w-full flex flex-col gap-1">
    <label [attr.for]="id" class="font-bold text-black">{{ label }}</label>
    <input
        class="flex-1 border border-gray-300 px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-300 rounded-lg bg-white"
        [ngClass]="{ invalid: campoInvalido }"
        [type]="type"
        [id]="id"
        [placeholder]="placeholder"
        [readOnly]="!!isReadOnly"
        [(ngModel)]="value"
        (blur)="aplicarMascara($event)"
        (change)="change($event)"
        autocomplete="off"
        pInputText
    />
</div>
